import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-16 px-4 text-center relative overflow-hidden bg-gradient-to-br from-white via-gray-50 to-yellow-50" data-id="element-109">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-110">
        <h1 className="text-4xl md:text-6xl font-black leading-tight mb-8 text-[#EAB308]" data-id="element-111">
          <span className="block mb-2 text-[#000000]" data-id="element-112">MegaPack</span>
          Detailer Argentino
        </h1>

        <div className="text-xl md:text-2xl font-medium text-gray-800 space-y-4 mb-10" data-id="element-113">
          <p className="text-[23px]" data-id="element-114">
            Todo el método de detailing profesional que necesitás, listo para
            aplicar.
          </p>
          <p className="text-[20px] font-[300]" data-id="element-115">
            Servicios claros, ordenados y sin improvisar. Dejá de trabajar mucho
            para ganar poco.
          </p>
        </div>

        <a href="https://checkout.construyeprogreso.com/cart/48119785324714:1" className="block mb-8 hover:scale-105 transition-transform duration-300" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/8GMhN7tg1NgJCW2pFp9XW9/Mockup.png" alt="MegaPack Detailer Argentino 6 Tomos" className="w-full max-w-2xl mx-auto drop-shadow-2xl" width={665} height={371} fetchPriority="high" decoding="async" data-id="element-117" />
        </a>

        <CTAButton href="https://checkout.construyeprogreso.com/cart/48119785324714:1" text="👉 SÍ, QUIERO ACCEDER AHORA" subtext="✅ Garantía de satisfacción de 30 días" data-id="element-118" />
      </div>
    </section>;
}